import { createPopper } from "@popperjs/core";
import { Coordinate } from "ol/coordinate";
import Overlay from "ol/Overlay";
import spinner from "../img/spinner_static.svg";
import { MOUSE_OVER_DEBOUNCE } from "./constants";
import { ICintorinConfig } from "./interfaces";

declare const CintorinConfig: ICintorinConfig;

interface IPopupIdentifier {
    id?: string,
    cid: number
}

var popperAnchor = document.createElement("div");
let loadingImg = document.createElement("img");
loadingImg.src = spinner;
let arrow = document.createElement("div");
arrow.id = "mapOverPopupArrow";
var popupContainer = document.createElement("div");
popupContainer.id = "mapOverPopupContainer";
var closeButton = document.createElement("button");
closeButton.type = "button";
closeButton.classList.add("btn-close");
closeButton.addEventListener("click", hidePopup);
var actualPopup = document.createElement("div");
actualPopup.id = "mapOverPopup";
popupContainer.appendChild(arrow);
popupContainer.appendChild(closeButton);
popupContainer.appendChild(actualPopup);
popperAnchor.appendChild(popupContainer);

const popper = createPopper(popperAnchor, popupContainer, {
    placement: "top", 
    modifiers: [
        {
            name: "arrow",
            options: {
                element: arrow
            }
        },
        {
            name: 'offset',
            options: {
              offset: [0, 8],
            },
        },
        {
            name: "flip",
            options: {
                boundary: document.getElementById("mapContainer"),
                padding: {
                    top: 35,
                    bottom: 35,
                    left: 35,
                    right: 35
                }
            }
        }
    ]
});

const mapPopup = new Overlay({
    element: popperAnchor
});
export default mapPopup;

var abortLoading: boolean = false;
var loadedId: IPopupIdentifier;
var loadingId: IPopupIdentifier;
var nextId: IPopupIdentifier;

var lastLoadingRequest = 0;

export function showPopup(position: Coordinate, newId: IPopupIdentifier) {
    abortLoading = false;
    mapPopup.setPosition(position);
    if (areNonNullAndEqual(newId, loadedId)) {
        popupContainer.setAttribute('data-show', '');
        popper.update();
        return;
    } else {
        popper.update();
        if (!areNonNullAndEqual(newId, loadingId) && !areNonNullAndEqual(newId, nextId)) {
            if (typeof(loadingId) !== "undefined") {
                nextId = newId; // zarad id do rady
                abortLoading = false;
            } else {
                // tu bude timeout
                lastLoadingRequest = Date.now();
                setTimeout(() => {
                    if (abortLoading) {
                        return;
                    }
                    if (lastLoadingRequest + MOUSE_OVER_DEBOUNCE < Date.now()) {
                        lastLoadingRequest = Date.now();
                        loadingId = newId;
                        setPopupToLoading();
                        loadPopup();
                    }
                }, MOUSE_OVER_DEBOUNCE);
            }
        }
    }
}

export function hidePopup() {
    abortLoading = true;
    nextId = undefined;
    loadedId = undefined;
    popupContainer.removeAttribute("data-show");
    popper.update();
}

export function isPopupShown(a:IPopupIdentifier) {
    return areNonNullAndEqual(a, loadedId);
}

function areNonNullAndEqual(a:IPopupIdentifier, b:IPopupIdentifier) {
    return typeof(a) !== 'undefined' && typeof(b) !== "undefined" && a.id === b.id && a.cid === b.cid;
}

async function loadPopup() {
    if (typeof(loadingId) === "undefined")
        return;
    fetch(CintorinConfig.baseUrl+"/api/htmlGetGravePopup.php",  {
        method: "POST",
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        }),
        body: "cId="+encodeURIComponent(loadingId.cid)+"&identifier="+encodeURIComponent(loadingId.id)
    }).then(response => {
        if (abortLoading) {
            abortLoading = false;
            loadingId = undefined;
            loadedId = undefined;
            nextId = undefined;
            popupContainer.removeAttribute("data-show");
            popper.update();
            return;
        }
        loadedId = loadingId;
        loadingId = nextId;
        nextId = undefined;
        if (typeof(loadingId) !== "undefined") {
            loadPopup();
            return;
        }
        if (response.ok && response.status == 200) {
            return response.text();
        }
    }).then(html => {
        if (html) {
            actualPopup.innerHTML = html;
            popper.update();
        }
    })
}

function setPopupToLoading() {
    if (typeof(loadingId) !== "undefined") {
        popupContainer.removeAttribute('data-show');
        popper.update();
        actualPopup.innerHTML = "";
        actualPopup.appendChild(loadingImg);
        popupContainer.setAttribute('data-show', '');
        popper.update();
    }
}